export const SCROLL_CATALOG_ID = 'catalog';
